export default function PHP_strcmp() {
  return (
    <div>
      <h1>PHP_strcmp</h1>
    </div>
  );
}
